// project import
import dashboard from './dashboard';
import storeManagement from './storeManagement';
import content from './content';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, storeManagement, content]
};

export default menuItems;
